import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const getFirebaseConfig = () => {
  try {
    const base64Config = import.meta.env.VITE_FIREBASE_CONFIG;
    if (!base64Config) {
      console.warn('VITE_FIREBASE_CONFIG environment variable not found');
      return {};
    }
    const decodedConfig = atob(base64Config);
    return JSON.parse(decodedConfig);
  } catch (error) {
    console.error('Error loading Firebase configuration:', error);
    return {};
  }
};

const firebaseConfig = getFirebaseConfig();

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);
